// Use the same matching rows for the list and its upper status cards.
export function matchesOrderSearch(order, search, fields) {
    const query = search.trim().toLocaleLowerCase('ru-RU')
    return !query || fields.some(field => String(order[field] ?? '').toLocaleLowerCase('ru-RU').includes(query))
}

export function summarizeOrders(orders) {
    const stats = { total: 0, open: 0, inProgress: 0, sent: 0, closedNotSent: 0, expired: 0, expiredOpen: 0, expiredProgress: 0 }
    const seen = new Set()
    for (const order of orders) {
        if (seen.has(order.id)) continue
        seen.add(order.id)
        stats.total++
        if (order.status === 'open') stats.open++
        if (order.status === 'open' || order.status === 'in_progress') stats.inProgress++
        if (order.is_sent) stats.sent++
        if (order.outcome === 'approved' && !order.is_sent) stats.closedNotSent++
        if (order.outcome === 'expired_open') stats.expiredOpen++
        if (order.outcome === 'expired_progress') stats.expiredProgress++
    }
    stats.expired = stats.expiredOpen + stats.expiredProgress
    return stats
}
